import { englishLabels } from "./labels-consts-en"
import { mexicanSpanishLabels } from "./labels-consts-es-mx"

const userLanguage = navigator.language || navigator.userLanguage

const getLabels = () => {
    if (userLanguage.startsWith("es")) return mexicanSpanishLabels
    else if (userLanguage.startsWith("en")) return englishLabels
    else return englishLabels
}

export const labels = getLabels()
